import axios, { AxiosRequestConfig } from 'axios'
import { api_resources_overview_cell_tag_path } from '../routes'

export type ResourcesOverviewCellTagPayload = {
  user_id: number
  date: string
  tag_id?: number | null
  time_minutes?: number
}

export function upsertResourcesOverviewCellTag(payload: ResourcesOverviewCellTagPayload) {
  const options: AxiosRequestConfig = {
    url: api_resources_overview_cell_tag_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }

  return axios(options).then(response => response.data)
}
